import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { LayoutWrapper } from './components/layout/LayoutWrapper'
import { AuthLayout } from './pages/auth/AuthLayout'
import { ProtectedRoute } from './components/auth/ProtectedRoute'
import { AuthGuard } from './components/auth/AuthGuard'
import DashboardPage from './pages/dashboard/page'
import FulfillmentPage from './pages/fulfillment/page'
import OrdersPage from './pages/orders/page'
import OperationPage from './pages/operation/page'
import ReportPage from './pages/report/page'
import SettingsPage from './pages/settings/page'
import TwoFactorPage from './pages/settings/TwoFactorPage'
import TwoFactorVerificationPage from './pages/auth/TwoFactorVerificationPage'
import TwoFactorTest from './pages/test/TwoFactorTest'
import LoginPage from './pages/auth/login'
import ForgotPasswordPage from './pages/auth/forgot-password'
import ResetPasswordPage from './pages/auth/reset-password'
import { SettingsProvider } from './providers/settings-provider'
import { LanguageProvider } from './contexts/LanguageContext'
import StoreInitializer from './components/StoreInitializer'
import { ToastContainer } from './components/ui/toast'

function App() {
  return (
    <LanguageProvider>
      <SettingsProvider>
        <Router>
          <div className="min-h-screen bg-gray-50">
            <StoreInitializer />
            <ToastContainer />
            <Routes>
              {/* Auth routes - redirect authenticated users */}
              <Route path="/auth" element={<AuthGuard><AuthLayout /></AuthGuard>}>
                <Route index element={<Navigate to="/auth/login" replace />} />
                <Route path="login" element={<LoginPage />} />
                <Route path="forgot-password" element={<ForgotPasswordPage />} />
                <Route path="reset-password/:token" element={<ResetPasswordPage />} />
              </Route>
              
              {/* Protected dashboard routes */}
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/" element={<ProtectedRoute><LayoutWrapper /></ProtectedRoute>}>
                <Route path="dashboard" element={<DashboardPage />} />
                <Route path="fulfillment" element={<FulfillmentPage />} />
                <Route path="orders" element={<OrdersPage />} />
                <Route path="operation" element={<OperationPage />} />
                <Route path="report" element={<ReportPage />} />
                <Route path="settings" element={<SettingsPage />} />
              </Route>
              
              {/* 2FA Routes (outside main layout) */}
              <Route path="/settings/2fa" element={<ProtectedRoute><TwoFactorPage /></ProtectedRoute>} />
              <Route path="/auth/2fa-verify" element={<TwoFactorVerificationPage />} />
              
              {/* Test Routes */}
              <Route path="/test/2fa" element={<TwoFactorTest />} />
            </Routes>
          </div>
        </Router>
      </SettingsProvider>
    </LanguageProvider>
  )
}

export default App
